import _ from "lodash";
import DatePicker from "@/grid-components/date_picker";
import DateRenderer from "@/grid-components/date_renderer";
import CustomValueRenderer from "@/grid-components/custom_value_renderer";
import NumberInput from "@/grid-components/number_input";
import IntInput from "@/grid-components/int_input";
import SelectInput from "@/grid-components/select_input";

const dateType = "date";
const numberType = "number";
const intType = "int";
const accuracyType = "accuracy";
const stringType = "string";

export const editableColumnTypes = {
  [dateType]: {
    cellEditorFramework: DatePicker,
    cellRendererFramework: DateRenderer,
  },

  [numberType]: {
    cellEditorFramework: NumberInput,
  },

  [intType]: {
    cellEditorFramework: IntInput,
  },

  [accuracyType]: {
    cellEditorFramework: SelectInput,
    cellRendererFramework: CustomValueRenderer,
    cellEditorParams: {
      values: ["Admin0", "Admin1", "Admin2+"],
    },
  },

  [stringType]: {},
};

const createViewableParams = type =>
  _.omit(type, ["cellEditor", "cellEditorFramework", "cellEditorParams"]);

export const viewableColumnTypes = _.mapValues(
  editableColumnTypes,
  createViewableParams
);

export const fieldTypes = {
  event_name: stringType,
  start_date: dateType,
  end_date: dateType,

  org_name: stringType,
  org_accuracy: accuracyType,
  org_lat: numberType,
  org_lon: numberType,

  dst_name: stringType,
  dst_accuracy: accuracyType,
  dst_lat: numberType,
  dst_lon: numberType,

  stock_total: intType,
  stock_male: intType,
  stock_female: intType,
  stock_in_camp: intType,
  stock_outdise_camp: intType,
  stock_age_cat_01: intType,
  stock_age_cat_02: intType,
  stock_age_cat_03: intType,

  new_total: intType,
  new_male: intType,
  new_female: intType,
  new_in_camp: intType,
  new_outdise_camp: intType,
  new_age_cat_01: intType,
  new_age_cat_02: intType,
  new_age_cat_03: intType,

  returns_total: intType,
  returns_male: intType,
  returns_female: intType,
  returns_in_camp: intType,
  returns_outdise_camp: intType,
  returns_age_cat_01: intType,
  returns_age_cat_02: intType,
  returns_age_cat_03: intType,

  returnees_total: intType,
  returnees_male: intType,
  returnees_female: intType,
  returnees_in_camp: intType,
  returnees_outdise_camp: intType,
  returnees_age_cat_01: intType,
  returnees_age_cat_02: intType,
  returnees_age_cat_03: intType,

  house_destroyed: intType,
  house_damaged: intType,

  url: stringType,
};

export const getFieldType = field => fieldTypes[field];
export const recordFields = Object.keys(fieldTypes);
